import { render, staticRenderFns } from "./ModalSingleHandle.vue?vue&type=template&id=fddea3d2&"
import script from "./ModalSingleHandle.vue?vue&type=script&lang=js&"
export * from "./ModalSingleHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports